const TRACE_STORAGE_KEY = 'reservationTraceId'
export const TRACE_HEADER = 'X-Reservation-Trace-Id'

export const getReservationTraceId = () =>
  sessionStorage.getItem(TRACE_STORAGE_KEY) || null

export const setReservationTraceId = (traceId) => {
  if (!traceId) return
  sessionStorage.setItem(TRACE_STORAGE_KEY, String(traceId))
}

export const clearReservationTraceId = () => {
  sessionStorage.removeItem(TRACE_STORAGE_KEY)
}

export const applyTraceHeader = (headers = {}) => {
  const traceId = getReservationTraceId()
  if (!traceId) return headers
  return { ...headers, [TRACE_HEADER]: traceId }
}

export const captureTraceFromResponse = (response) => {
  const traceId =
    response?.headers?.[TRACE_HEADER] ||
    response?.headers?.['x-reservation-trace-id'] ||
    response?.data?.traceId
  if (traceId) setReservationTraceId(traceId)
}
